import './Testimonials.css';
import React from 'react';
import '../App.css';

function Testimonials() {


    return (
        <div className="testimonials-container">

            <h1>Testimonials</h1>
            <hr class="solid"></hr>
            <p className='testimonial-sentance'>A small collection of what my peers and clientelle have had to say!
            </p>
            <div className='testimonials-content-container'>
                <div class="testimonial-quote"><p>"Morgan did tremendous a job creating our website for Ashley Industrial Molding.
                    From start to finish, his professionalism, creativity, and attention to detail were nothing short of extraordinary.
                    He was able to take my vague ideas and transformed them into a stunning website that captures the nature and culture of our business.

                    His ability to understand my concept and translate it into a user-friendly, visually appealing site exceeded all my expectations.
                    The project was completed on time and within budget.
                    His focus on clearly communicating his progress and his intentions of the overall vision of the website led to the delivery of a website that we are incredibly proud of.

                    Morgan has a commitment to excellence and a deep passion for design.

                    We are extremely proud with the results and highly recommend Morgan to anyone looking for a top-notch website designer.
                    His work has increased our online presence and I am confident it will make a significant impact to our business.

                    "</p></div>
                <div class="testimonial-quote"><p>"coming soon"</p></div>
                <div class="testimonial-quote"><p>"coming soon"</p></div>
                <div class="testimonial-quote"><p>"coming soon"</p></div>
                <div class="testimonial-quote"><p>"coming soon"</p></div>
                <div class="testimonial-quote"><p>"coming soon"</p></div>

            </div>
        </div>
    )
}

export default Testimonials